import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AzureBlobStorageService } from 'src/app/core/_services/azure-blob-storage.service';
import { ApiService } from './_services/api/api.service';
import { ErrorDialogService } from './_services/error-dialog/error-dialog.service';
import { GlobalErrorHandler } from './_services/error-handler/error-handler.service';
import { AuthGuard } from './_services/guards/auth.guard';
import { LoaderInterceptor } from './_services/interceptors/loader.interceptor';
import { UserDataService } from './_services/user-data/user-data.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatDialogModule
  ],
  providers: [
    AuthGuard,
    UserDataService,
    ApiService,
    ErrorDialogService,
    // AzureBlobStorageService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  exports: []
})
export class CoreModule { }
